import { useRecoilState, useRecoilValue } from 'recoil';
import BootstrapNavbar from 'react-bootstrap/Navbar';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import CloseIcon from '@mui/icons-material/Close';

import * as K from 'common/constants';
import ELEMENT from 'common/element';
import { logoState, navbarVariantState } from 'components/common/Managers/SettingsManager.state';
import { isLiveTailActiveState } from 'components/search/SearchLogsPage/LogResultsContainer.hooks';

import Link from 'components/common/Link/Link';
import Button from 'components/common/Button/Button';
import Toolbar from 'components/common/Toolbar/Toolbar';

import './LiveTailHeader.scss';

type LiveTailHeaderProps = {
  exitLiveTail: (route?: K.ROUTE) => void;
};

function LiveTailHeader({ exitLiveTail }: LiveTailHeaderProps): JSX.Element {
  const { logoUrl, logoWidth } = useRecoilValue(logoState);
  const navbarVariant = useRecoilValue(navbarVariantState);
  const [isActive, setIsActive] = useRecoilState(isLiveTailActiveState);

  const leftItems = [<div className="LiveTailHeader__Title">Live Tail</div>];

  const activeStatusButton = isActive ? (
    <Button
      onClick={(): void => setIsActive(false)}
      leftIcon={<PauseIcon fontSize="small" />}
      testId={ELEMENT.liveTailPauseButton}
    >
      Pause
    </Button>
  ) : (
    <Button
      onClick={(): void => setIsActive(true)}
      leftIcon={<PlayArrowIcon fontSize="small" />}
      testId={ELEMENT.liveTailResumeButton}
    >
      Resume
    </Button>
  );

  const rightItems = [
    activeStatusButton,
    <CloseIcon
      data-test-id={ELEMENT.liveTailHeaderCloseIcon}
      className="LiveTailHeader__CloseIcon"
      fontSize="large"
      onClick={(): void => exitLiveTail()}
    />,
  ];

  return (
    <BootstrapNavbar className="navbar-scalyr" variant={navbarVariant}>
      <BootstrapNavbar.Brand as={Link} onClick={(): void => exitLiveTail(K.ROUTE.ROOT)}>
        <img alt={K.PRODUCT_NAME} src={logoUrl} style={{ width: logoWidth }} />
      </BootstrapNavbar.Brand>
      <Toolbar leftItems={leftItems} rightItems={rightItems} className="LiveTailHeader__Toolbar" />
    </BootstrapNavbar>
  );
}

export default LiveTailHeader;
